export const formatTime = (time: number, hours: boolean): string => {
  if (hours) {
    const h = Math.floor(time / 3600)
    time = time - h * 3600

    const m = Math.floor(time / 60)
    const s = Math.floor(time % 60)

    return zeros(h, 2) + ':' + zeros(m, 2) + ':' + zeros(s, 2)
  } else {
    const m = Math.floor(time / 60)
    const s = Math.floor(time % 60)

    return zeros(m, 2) + ':' + zeros(s, 2)
  }
}

export const pluralizeRu = (count: number, forms: [string, string, string]): string => {
  const absCount = Math.abs(count) % 100
  const lastDigit = absCount % 10

  if (absCount > 10 && absCount < 20) return forms[2]
  if (lastDigit > 1 && lastDigit < 5) return forms[1]
  if (lastDigit === 1) return forms[0]

  return forms[2]
}

export const formatMinutes = (seconds: number): string => {
  const minutes = Math.round(seconds / 60)
  return `${minutes} ${pluralizeRu(minutes, ['минута', 'минуты', 'минут'])}`
}

const zeros = (n:number, c:number) => {
  let nz = '' + n
  while (nz.length < c) {
    nz = '0' + nz
  }
  return nz
}
